"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConventionDetail = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const withLazy_1 = __importDefault(require("../../../common/decorators/withLazy"));
const Website_1 = __importDefault(require("../../../common/components/CallToActions/Website"));
const Activities_1 = __importDefault(require("../Pages/Activities"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const CallArea_1 = __importDefault(require("../../../common/components/CallToActions/CallArea"));
const CallToActionItemNew_1 = __importDefault(require("./CallToActionItemNew"));
const globalVariables_1 = require("../../../common/globalVariables");
const Map = (0, withLazy_1.default)((0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require(
/* webpackChunkName: "Map1" */ "../../../common/components/CallToActions/Map")))));
;
const ConventionDetailWrapper = styled_components_1.default.div `
  height: 100%;
  color: rgba(0, 0, 0, 0.6);

  @media (orientation: landscape) {
    overflow: scroll;
  }

  .box-wrapper {
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
    margin: 0 auto;
  }

  .tab-section {
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HEADER}px;
    margin: 0 auto;
  }

  .convention {
    &-tab {
      border-bottom: 2px solid #f3f3f3;
    }

    &-details {
      max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_CONTAINER}px;
      margin: 0 auto;
      padding: 16px;
    }

    &-image {
      img {
        border-radius: 16px;
        width: 100%;
        max-height: 400px;
        object-fit: cover;
      }
    }

    &-title {
      font-weight: 400;
      margin: 30px 0 25px;
      color: #1d1d1d;
    }

    &-call-to-action {
      border-top: 1px solid #f3f3f3;
      border-bottom: 1px solid #f3f3f3;
      padding: 12px 0 8px;
    }
  }
`;
const CallToActions = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  gap: 5px;
`;
const ConventionDetail = (props) => {
    const [activeTabIndex, setActiveTabIndex] = (0, react_1.useState)(0);
    const [disableButton, setDisableButton] = (0, react_1.useState)(false);
    const [callToAction, setCallToAction] = (0, react_1.useState)("");
    const convention = props.conventionData;
    const permittedActionsList = ["call", "map"];
    const handleActiveTabUpdate = (evt, newValue) => {
        setActiveTabIndex(newValue);
    };
    const handleCheckout = () => {
        setDisableButton(true);
        apiService_1.default
            .checkOutConvention(props.currentLocale, props.userData.token, convention.code)
            .then(() => {
            apiService_1.default
                .getActivities({
                locale: props.currentLocale,
                userToken: props.userData.token,
            })
                .then((activities) => {
                props.updateStore("unfilteredActivities", activities);
            });
            setDisableButton(false);
            props.history.push({
                pathname: `${props.baseUrl}/conventions`,
                search: props.location.search,
                state: "convention-checkout",
            });
        });
    };
    (0, react_1.useEffect)(() => {
        const { contentId, code } = props.match.params;
        if (contentId && code) {
            const content = { contentId };
            helpers_1.Helpers.openModal(modalEnums_1.default.ACTIVITY_DETAILS, {
                content,
                redirectOnClose: `${props.baseUrl}/conventions/${code}`,
            });
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const lastUrlParam = props.location.pathname.split("/").pop();
        if (permittedActionsList.includes(lastUrlParam)) {
            setCallToAction(lastUrlParam);
        }
        else {
            setCallToAction("");
        }
    }, [props.location.pathname]);
    if (callToAction) {
        if (callToAction === "call") {
            return react_1.default.createElement(CallArea_1.default, { activeItem: { content: convention, type: "convention" } });
        }
        return react_1.default.createElement(Map, { activeItem: { content: convention, type: "convention" } });
    }
    return (react_1.default.createElement(ConventionDetailWrapper, { "data-testid": "convention-detail-wrapper" },
        react_1.default.createElement(material_1.Box, { className: "tab-section" },
            react_1.default.createElement(material_1.Tabs, { value: activeTabIndex, onChange: handleActiveTabUpdate, variant: "fullWidth" },
                react_1.default.createElement(material_1.Tab, { label: i18n_js_1.default.t("dictionary.activities.title"), className: "convention-tab" }),
                react_1.default.createElement(material_1.Tab, { label: i18n_js_1.default.t("about_the_convention"), className: "convention-tab" }))),
        react_1.default.createElement(material_1.Box, { className: "box-wrapper" }, activeTabIndex === 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Activities_1.default, { conventionCode: convention.code })))),
        react_1.default.createElement(material_1.Box, { className: "convention-details" },
            activeTabIndex === 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Box, { className: "convention-image" },
                    convention.primaryImage &&
                        react_1.default.createElement("img", { src: convention.primaryImage, alt: "Convention Img" }),
                    react_1.default.createElement(material_1.Typography, { variant: "h4", className: "convention-title" },
                        " ",
                        convention.title,
                        " ")),
                react_1.default.createElement(material_1.Box, { className: "convention-call-to-action" },
                    react_1.default.createElement(CallToActions, null,
                        convention.website && (react_1.default.createElement(Website_1.default, { type: "circle", url: convention.website, text: i18n_js_1.default.t("website") })),
                        convention.phone && (react_1.default.createElement(CallToActionItemNew_1.default, { icon: "call", destination: "call", pushToDestination: true, text: i18n_js_1.default.t("tab_call"), activeItem: { content: convention } })),
                        convention.lat && convention.lng && (react_1.default.createElement(CallToActionItemNew_1.default, { activeItem: { content: convention }, icon: "room", destination: "map", pushToDestination: true, text: i18n_js_1.default.t("map") })))),
                react_1.default.createElement(material_1.Box, null, convention.text && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: convention.text,
                    } }))))),
            react_1.default.createElement(material_1.Button, { variant: "outlined", fullWidth: true, size: "large", disabled: disableButton, onClick: handleCheckout, color: "destroy" }, i18n_js_1.default.t("log_out_convention")))));
};
exports.ConventionDetail = ConventionDetail;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    baseUrl: store.getValue("baseUrl"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ConventionDetail));
